import {inject, Injectable} from '@angular/core';
import {BaseTinyService} from "../BaseTinyService";
import {GlobalModelService} from "../GlobalModel.service";

/**
 * Partition picked in the topbar, shared by Gateways, Virtual metrics, Diagnostics and Alerts.
 * Falls back to the logged user's own partition until one is picked.
 */
@Injectable({
  providedIn: 'root'
})
export class PartitionSelectionService extends BaseTinyService {

  private gmService: GlobalModelService = inject(GlobalModelService);
  private _selectedPartitionId: number | null = null;

  get selectedPartitionId(): number | null {
    if (this._selectedPartitionId === null)
      this._selectedPartitionId = this.gmService.user?.partition?.id ?? null;
    return this._selectedPartitionId;
  }

  set selectedPartitionId(value: number | null) {
    this._selectedPartitionId = value;
  }

  cleanupServiceFields(): void {
    this._selectedPartitionId = null;
  }
}
